import type {App, DirectiveBinding} from "vue";
type SentinelElement = HTMLElement & {__vueSentinelObserver__?: IntersectionObserver};
interface SentinelBinding {callback: () => void; options?: IntersectionObserverInit}
export default {
    install(Vue: App) {
        Vue.directive('observer-sentinel', {
            mounted(el: SentinelElement, binding: DirectiveBinding<SentinelBinding>) {
                const options = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.1,
                    ...binding.value.options
                };

                const observer = new IntersectionObserver((entries) => {
                    const entry = entries[0];
                    if (entry.isIntersecting && typeof binding.value.callback === 'function') {
                        binding.value.callback();
                    }
                }, options);

                observer.observe(el);
            },
            unmounted(el: SentinelElement) {
                if (el.__vueSentinelObserver__) {
                    el.__vueSentinelObserver__.disconnect();
                    delete el.__vueSentinelObserver__;
                }
            }
        });
    },
};